(function(angular){
    'use strict';

    angular.module('app').directive('apPatientPortal', ApPatientPortalDirective);

    function ApPatientPortalDirective() {
        return {
            restrict: 'E',
            controller: [
                '$rootScope',
                '$scope',
                '$state',
                'CustomModuleRunService',
                ApPatientPortalCtrl,
            ],
            templateUrl: '/app/views/components/apPatientPortal.html',
        };
    }

    function ApPatientPortalCtrl(
        $rootScope,
        $scope,
        $state,
        CustomModuleRunService
    ) {
        var vm = {
            loadedAngular: false,
            
            isLoginView: isLoginView,
            onAngularInitialized: onAngularInitialized,
            shouldHideFooter: shouldHideFooter,
            shouldHideToolbar: shouldHideToolbar,
        };

        $scope.vm = vm;

        function isLoginView() {
            return $rootScope.loginView;
        }

        function onAngularInitialized() {
            CustomModuleRunService.run();

            if ($state.current && $state.current.name) {
                // Reload the state since none of the listeners were setup before the initial state change.
                // For instance, listeners like onStart, or onSuccess in source/web/www/modules/common/init.js.
                // This call essentially does the same thing as $state.reload(),
                // except it also uses location:false to not update the url.
                // This would have an effect when you have an initial url that corresponds to a route
                // that doesn't completely match the query string.
                //
                // Example to show the difference:
                // initial url: http://localhost:4200/#/transactionComplete?m=55&i=55
                // (Option 1)
                // $state.reload() would transition to transactionComplete state, and then change the url
                // to http://localhost:4200/#/transactionComplete,
                // because there are currently no query parameters defined in the route for the state,
                // so the ones from the initial url are not kept
                // (Option 2)
                // This call below with location:false would transition to transactionComplete state, and then NOT change the url
                // According to the docs: If false, it will not update the url in the location bar.
                $state.transitionTo($state.current, $state.params, {
                    reload: true,
                    inherit: false,
                    notify: false,
                    location: false,
                });
            }

            vm.loadedAngular = true;
        }

        function shouldHideFooter() {
            return $rootScope.hideFooter;
        }

        function shouldHideToolbar() {
            return $rootScope.hideToolbar;
        }
    }
})(window.angular);
